import React from 'react';
import { Building2, Package, Wrench, CheckCircle2 } from 'lucide-react';
export function CommercialStrip() {
  return <section className="bg-brand-green text-white py-16 lg:py-24" data-id="element-116">
      <div className="max-w-7xl mx-auto px-4" data-id="element-117">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center" data-id="element-118">
          <div className="lg:col-span-5" data-id="element-119">
            <span className="text-brand-gold font-bold tracking-wider uppercase text-xs mb-4 block flex items-center gap-2" data-id="element-120">
              <span className="w-6 h-px bg-brand-gold" data-id="element-121"></span>
              B2B & Community Projects
            </span>
            <h2 className="text-3xl lg:text-4xl font-serif font-bold mb-6 leading-tight" data-id="element-122">
              Commercial mailbox projects need more than a product grid
            </h2>
            <p className="text-brand-cream/90 text-lg mb-6 leading-relaxed" data-id="element-123">
              Commercial mailbox requirements vary by product, location,
              delivery setup, and USPS/project requirements. MidAtlantic can
              help review the door count, numbering, parcel locker needs, and
              installation setup before ordering.
            </p>

            <ul className="space-y-3 mb-8 text-brand-cream/80 text-sm" data-id="element-124">
              <li className="flex items-start gap-2" data-id="element-125">
                <CheckCircle2 size={18} className="text-brand-gold shrink-0 mt-0.5" data-id="element-126" />
                <span data-id="element-127">CBU / cluster box units & 4C horizontal mailboxes</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-128">
                <CheckCircle2 size={18} className="text-brand-gold shrink-0 mt-0.5" data-id="element-129" />
                <span data-id="element-130">Parcel lockers & private delivery mailboxes</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-131">
                <CheckCircle2 size={18} className="text-brand-gold shrink-0 mt-0.5" data-id="element-132" />
                <span data-id="element-133">Replacement commercial locks, hinges, and doors</span>
              </li>
            </ul>

            <div className="flex flex-wrap gap-4" data-id="element-134">
              <a href="/6m8/commercial-mailboxes-lockers.html" className="bg-brand-gold hover:bg-brand-gold/90 text-brand-charcoal px-6 py-3 rounded-md font-bold transition-colors shadow-sm" data-id="element-135">
                Shop commercial mailboxes
              </a>
              <a href="/ContactUs.html" className="bg-transparent hover:bg-white/10 border border-white/30 text-white px-6 py-3 rounded-md font-semibold transition-colors" data-id="element-136">
                Request project help
              </a>
            </div>
          </div>

          <div className="lg:col-span-7" data-id="element-137">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 lg:gap-6" data-id="element-138">
              <a href="/6m8/commercial-mailboxes-lockers/centralized-delivery-mailboxes-kiosks.html" className="bg-white/5 border border-white/10 hover:bg-white/10 hover:border-brand-gold transition-all rounded-xl p-6 lg:p-8 flex flex-col items-center text-center group" data-id="element-139">
                <div className="w-14 h-14 bg-brand-gold/10 text-brand-gold rounded-full flex items-center justify-center mb-5 group-hover:scale-110 transition-transform" data-id="element-140">
                  <Building2 size={28} strokeWidth={1.5} data-id="element-141" />
                </div>
                <h3 className="font-serif font-bold text-lg mb-2" data-id="element-142">
                  Centralized Delivery
                </h3>
                <p className="text-sm text-brand-cream/70 leading-relaxed" data-id="element-143">
                  CBU and 4C systems
                </p>
              </a>

              <a href="/6m8/commercial-mailboxes-lockers/parcel-lockers.html" className="bg-white/5 border border-white/10 hover:bg-white/10 hover:border-brand-gold transition-all rounded-xl p-6 lg:p-8 flex flex-col items-center text-center group" data-id="element-144">
                <div className="w-14 h-14 bg-brand-gold/10 text-brand-gold rounded-full flex items-center justify-center mb-5 group-hover:scale-110 transition-transform" data-id="element-145">
                  <Package size={28} strokeWidth={1.5} data-id="element-146" />
                </div>
                <h3 className="font-serif font-bold text-lg mb-2" data-id="element-147">
                  Parcel lockers
                </h3>
                <p className="text-sm text-brand-cream/70 leading-relaxed" data-id="element-148">
                  Secure package management
                </p>
              </a>

              <a href="/6m8/commercial-mailboxes-lockers/replacement-commercial-locks-hinges-doors.html" className="bg-white/5 border border-white/10 hover:bg-white/10 hover:border-brand-gold transition-all rounded-xl p-6 lg:p-8 flex flex-col items-center text-center group" data-id="element-149">
                <div className="w-14 h-14 bg-brand-gold/10 text-brand-gold rounded-full flex items-center justify-center mb-5 group-hover:scale-110 transition-transform" data-id="element-150">
                  <Wrench size={28} strokeWidth={1.5} data-id="element-151" />
                </div>
                <h3 className="font-serif font-bold text-lg mb-2" data-id="element-152">
                  Replacement parts
                </h3>
                <p className="text-sm text-brand-cream/70 leading-relaxed" data-id="element-153">
                  Commercial doors, locks, and hardware
                </p>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}